/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
type useListingStructuredData_listing$ref = any;
export type CompositePropertyType = "APPT" | "BUILDING" | "COMMERCIAL" | "GASTRO" | "HOUSE" | "HOUSE_APPT" | "OTHER" | "PARK" | "PROP" | "ROOM";
export type OfferType = "buy" | "rent";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AggregatesListingStructuredData_listing$ref: FragmentReference;
declare export opaque type AggregatesListingStructuredData_listing$fragmentType: AggregatesListingStructuredData_listing$ref;
export type AggregatesListingStructuredData_listing = {|
  +offerType: OfferType,
  +compositePropertyType: CompositePropertyType,
  +slug: string,
  +description: ?string,
  +translatedDescription: ?string,
  +$fragmentRefs: useListingStructuredData_listing$ref,
  +$refType: AggregatesListingStructuredData_listing$ref,
|};
export type AggregatesListingStructuredData_listing$data = AggregatesListingStructuredData_listing;
export type AggregatesListingStructuredData_listing$key = {
  +$data?: AggregatesListingStructuredData_listing$data,
  +$fragmentRefs: AggregatesListingStructuredData_listing$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AggregatesListingStructuredData_listing",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "offerType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "compositePropertyType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "translatedDescription",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useListingStructuredData_listing"
    }
  ],
  "type": "AggregatesListing",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '66befb5a08de5ceb897b224a2da800c5';

export default node;
